import { fetch } from '../'

export default {
  async get (count) {
    let response = await fetch(`/wp-json/wpvue/v1/tweets/${window.lang ? '?lang=' + window.lang : ''}`)
    let data = await response.json()
    return response.ok ? data : []
  }
}
